import { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './Portal.module.scss';

export default class Portal extends PureComponent {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.el.setAttribute('class', styles.portal);
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

Portal.displayName = 'Portal';

Portal.propTypes = { children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]) };
